var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PartsFinish"},[_c('div',{staticClass:"PartsFinish-title"},[_vm._v(_vm._s(_vm.$t('part.finishTitle')))]),_c('div',{staticClass:"PartsFinish-msg"},[_vm._v(_vm._s(_vm.$t('part.finishMsg')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }